<template>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">SOURCE - {{ source }}</th>
        <th scope="col">PREPARED</th>
        <th scope="col">TRANSFORMED</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="width: 30%; white-space: pre-wrap">
          <pre>{{ Model.Raw }}</pre>
          <button v-show="isPdf" @click="downloadFile">Download</button>
        </td>
        <td style="width: 30%; white-space: pre-wrap">
          <pre>{{ Model.Prepared }}</pre>
        </td>
        <td style="width: 40%; white-space: pre-wrap">
          <pre>{{ Model.Transformed }}</pre>
        </td>
      </tr>
      <tr v-show="showTrace">
        <td colspan="3">
          <h4>TRACE</h4>
          <div>
            <pre>{{ Model.Trace }}</pre>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<style scoped>
.marketWripper {
  padding: 10px;
}

.buttons {
  text-align: center;
}

.customSelect {
  margin-right: 10px;
  margin-left: 12px;
  height: 40px;
  -webkit-appearance: menulist;
}
</style>
<script>
// import {
//   ArgonButton,
// } from "@/components/exporter.js";
import { SendGETServerAPI, SendPOSTServerAPI } from "@/customFunctions/Api.js";
import { Toaster } from "@/customFunctions/Utils.js";
import axios from "axios";

export default {
  name: "data-pipeline-instrument",
  data() {
    return {
      Model: {},
      selectedMarketId: "",
      saveButtonClicked: false,
      origin: window.location.origin,
      source: null,
      tabulation: "  ",
      trayportItemKey: null,
      trayportItemKeys: [
        "ORDER",
        "TRADE",
        "INSTORDERSUMMARY",
        "INSTTRADESUMMARY",
      ],
      preparedParsed: null,
      ECOSTradeID: 0,
      showTrace: false,
      isPdf: false,
      filenameToDownload: "#",
    };
  },
  async mounted() {
    const comp = this;
    window.addEventListener("keydown", (e) => {
      if (e.key == "Z" && e.ctrlKey && e.altKey) {
        comp.showTrace = true;
      }
    });

    this.$store.commit("setShowPreloader", true);
    try {
      const response = await SendGETServerAPI(
        `dataPipelineTransformation/${this.$route.params.pathMatch[0]}`,
        {
          Authorization: "Bearer " + this.$store.state.security.accessToken,
        }
      );

      if (response.Trace.S3RawFilePath.toLowerCase().includes("evoid")) {
        this.source = "EVOID";
      } else if (response.Trace.S3RawFilePath.includes("screen")) {
        this.source = "EvoScreen";
      } else if (response.Trace.S3RawFilePath.includes("trayport")) {
        this.source = "Trayport";
      } else if (response.Trace.S3RawFilePath.includes("ECOS")) {
        this.source = "ECOS";
      } else if (response.Trace.S3RawFilePath.includes("nodal")) {
        this.isPdf = true;
        this.source = "Nodal";
      } else if (response.Trace.S3RawFilePath.includes("pjm")) {
        this.isPdf = true;
        this.source = "PJM";
      } else if (response.Trace.S3RawFilePath.includes("poweroptions")) {
        this.source = "PowerOptions";
      }

      if (this.isPdf) {
        let fname = response.Trace.S3RawFilePath;
        this.filenameToDownload =
          process.env.VUE_APP_SERVER_URL +
          "dataPipelineTransformation/download/" +
          fname.substr(0, fname.indexOf("/")) +
          "/" +
          encodeURIComponent(fname.substr(fname.indexOf("/") + 1));
      }

      if (response.TransformedSuccess)
        this.Model.Transformed = this.processTran(
          response.Transformed,
          response.Trace.MarketDataId.toUpperCase(),
          JSON.parse(response.Terms),
          JSON.parse(response.Instruments)
        );
      else this.Model.Transformed = response.Transformed;

      if (response.PreparedSuccess)
        this.Model.Prepared = this.processPrep(
          response.Prepared,
          response.Trace.MarketDataId.toUpperCase()
        );
      else this.Model.Prepared = response.Prepared;

      if (this.isPdf) this.Model.Raw = response.Raw;
      else
        this.Model.Raw = this.processRaw(
          response.Raw,
          response.Trace.S3RawFileRecordIndex
        );

      this.Model.Trace = response.Trace;
    } catch (ex) {
      console.log(ex);
    }

    this.$store.commit("setShowPreloader", false);
  },
  // components: { ArgonInput, ArgonButton, ArgonTextArea },
  methods: {
    downloadFile() {
      let url = this.filenameToDownload;
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + this.$store.state.security.accessToken,
        },
      })
        .then((response) => {
          this.forceFileDownload(
            response,
            url.substr(url.lastIndexOf("/") + 1).replace("%2F", "-")
          );
        })
        .catch((ex) => console.log(ex));
    },
    forceFileDownload(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    processRaw(raw, s3RawFileRecordIndex) {
      try {
        let s = raw;
        let a = [];
        let isJson = this.source != "Trayport" && this.source != "ECOS";
        if (this.source === "Trayport") {
          a = s
            .split('<?xml version="1.0" encoding="UTF-16"?>'.toLowerCase())
            .filter((x) => x != "")
            .map((x) => x.substr(x.indexOf("<")));
        } else if (this.source === "ECOS") {
          a = s
            .split("</Trade>")
            .filter((x) => x != "")
            .map((x) => x + "</Trade>");
        } else if (s[0] != "[") {
          s = "[" + s.replaceAll("}{", "},{") + "]";
          a = JSON.parse(s);
          if (a[0].update)
            a = a.map((x) => x.update || x).reduce((x, y) => x.concat(y));
        } else {
          a = JSON.parse(s);
        }

        let item = "";
        if (this.source === "Trayport") {
          let trRowIndx = 0;
          let inRowIndx = s3RawFileRecordIndex;
          while (s3RawFileRecordIndex > 0 && this.source == "Trayport") {
            let currData = this.preparedParsed[trRowIndx].data;
            let keys = Object.getOwnPropertyNames(currData).filter(
              (x) => this.trayportItemKeys.indexOf(x) >= 0
            );
            let dec =
              keys.length > 1
                ? keys.reduce((x, y) => {
                    let dx = currData[x];
                    let dy = currData[y];
                    let c1 = Array.isArray(dx)
                      ? dx
                        ? dx.length
                        : 0
                      : dx
                      ? 1
                      : 0;
                    let c2 = Array.isArray(dy) ? dx.length : 1;
                    return (Number.isInteger(x) ? x : 0) + c1 + c2;
                  })
                : currData[keys[0]];
            dec = Number.isInteger(dec)
              ? dec
              : Array.isArray(dec)
              ? dec.length
              : 1;
            s3RawFileRecordIndex -= dec;
            if (s3RawFileRecordIndex >= 0) {
              trRowIndx++;
              inRowIndx = s3RawFileRecordIndex;
            }
          }
          item =
            a[this.source == "Trayport" ? trRowIndx : s3RawFileRecordIndex];
          let itemIndx = 0;
          if (inRowIndx > 0) {
            itemIndx =
              this.nIndexOf(item, "INSTSPECIFIER", 0, inRowIndx - 1) - 1;
            itemIndx = item.indexOf("<" + this.trayportItemKey, itemIndx);
          } else {
            itemIndx = item.indexOf("<" + this.trayportItemKey, itemIndx);
          }
          item = item.substring(
            itemIndx,
            item.indexOf("/" + this.trayportItemKey, itemIndx) +
              this.trayportItemKey.length +
              2
          );
        } else {
          item = a[s3RawFileRecordIndex];
        }
        return isJson ? JSON.stringify(item, null, this.tabulation) : item;
      } catch (ex) {
        console.log(ex);
      }
    },
    processPrep(prep, marketDataId) {
      try {
        let s = prep.split("\n");
        s = s.filter((x) => {
          return x != "";
        });
        let a = JSON.parse("[" + s.join(",") + "]");
        //temp>
        a = a[0].datas ? a[0].datas.data : a;
        if (!Array.isArray(a)) a = [a];
        //temp<
        this.preparedParsed = JSON.parse(JSON.stringify(a));

        let searchResult = a.filter((i) => {
          let found = false;
          if (this.source != "Trayport") {
            found =
              (i.marketDataId || i.data.marketDataId || "").toUpperCase() ===
              marketDataId;
            // trayportKey = null;
          } else {
            this.trayportItemKeys.forEach((x) => {
              if (!this.trayportItemKey) {
                this.trayportItemKey = this.checkTrayportPreparedKey(
                  i,
                  x,
                  marketDataId
                );
                if (this.trayportItemKey) found = true;
              }
            });
          }
          return found;
        })[0];

        if (this.source == "ECOS") {
          this.ECOSTradeID = searchResult.TradeID;
        }
        if (
          this.source == "Trayport" &&
          Array.isArray(searchResult.data[this.trayportItemKey])
        ) {
          searchResult.data[this.trayportItemKey] = searchResult.data[
            this.trayportItemKey
          ].filter((x) => x.marketDataId.toUpperCase() == marketDataId);
        }
        let item = searchResult;
        if (this.trayportItemKey) {
          this.trayportItemKeys.forEach((x) => {
            if (this.trayportItemKey != x) delete item.data[x];
          });
        }
        return JSON.stringify(item, null, this.tabulation) || "";
      } catch (ex) {
        console.log(ex);
      }
    },
    processTran(tran, marketDataId, terms, instruments) {
      try {
        let s = tran.split("\n");
        s = s.filter((x) => {
          return x != "";
        });
        let a = JSON.parse("[" + s.join(",") + "]");

        let item = a.filter((i) => {
          return i.marketDataId.toUpperCase() == marketDataId;
        })[0];

        let term = terms.filter((i) => {
          return i.Id.toUpperCase() == item.instrumentTermId.toUpperCase();
        })[0];
        let instrument = instruments.filter((i) => {
          return i.Id.toUpperCase() == item.instrumentSourceId.toUpperCase();
        })[0];
        item.instrumentTerm = term ? term.Value : null;
        item.instrument = instrument ? instrument.Name : null;

        return JSON.stringify(item, null, this.tabulation) || "";
      } catch (ex) {
        console.log(ex);
      }
    },
    nIndexOf(str, search, startingIndex, n) {
      if (n > 0)
        return this.nIndexOf(
          str,
          search,
          str.indexOf(search, startingIndex) + search.length,
          n - 1
        );
      else return str.indexOf(search, startingIndex);
    },
    checkTrayportPreparedKey(i, key, searchMarketDataId) {
      let trayportItemKey = null;
      let item = i.data[key];
      if (
        item &&
        (Array.isArray(item)
          ? item.filter(
              (x) => x.marketDataId.toUpperCase() == searchMarketDataId
            ).length > 0
          : item.marketDataId.toUpperCase() == searchMarketDataId)
      )
        trayportItemKey = key;

      return trayportItemKey;
    },
    async Save() {
      this.saveButtonClicked = true;
      const marketId = this.Model.Markets.find(
        (x) => x.Name === this.selectedMarketId
      ).Id;

      const body = {
        Id: this.Model.Id,
        Name: this.Model.Name,
        MarketId: marketId,
        Description: this.Model.Description,
        ContractSpecification: this.Model.ContractSpecification,
      };
      const resp = await SendPOSTServerAPI(
        "dataPipelineTransformation/Instrument/Edit",
        {
          Authorization: "Bearer " + this.$store.state.security.accessToken,
        },
        JSON.stringify(body)
      ).then((r) => r.json());

      if (resp.isOk) this.Toaster("Data has been saved.", "Success", "success");
      else this.Toaster("Some Server Error...", "Error", "danger");

      this.saveButtonClicked = false;
    },
    Close() {
      window.close();
    },
  },
  setup() {
    return { Toaster };
  },
  watch: {
    "Model.Description"(value) {
      if (value.length > 5000) {
        Toaster("Description Max Length is 5000...", "Error", "danger");
        return;
      }
    },
  },
};
</script>
